import React from 'react';
import { BasicCollapse } from 'ui-lib';
import { IConfigureStepProps } from '../component-version-wizard.types';
import { DockerImagesPickerFormItem } from '../../docker-images-picker';
import css from '../../raptor-components.css';

export const DockerImageConfigureStep = (props: IConfigureStepProps): JSX.Element => {
    return (
        <BasicCollapse
            className={css['manifest-panel']}
            key={props.selectedPlatforms.map((platform) => platform.uuid).join('|')}
            defaultActiveKey={props.selectedPlatforms.map((platform) => platform.uuid)}
            panels={props.selectedPlatforms.map((platform) => ({
                key: platform.uuid,
                header: platform.displayName,
                content: (
                    <DockerImagesPickerFormItem
                        name={['manifests', platform.uuid, 'dockerImages']}
                        label='Docker Image'
                        selectionType='single'
                        isRequired={true}
                        source={props.dockerImagesSource}
                    />
                ),
            }))}
        />
    );
};
